export class JsonUtils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static tryParse<T = any>(value: string): T {
    try {
      const parsed = JSON.parse(value);
      return parsed as T;
    } catch (error) {
      if (error instanceof Error) {
        const message = error.message;
        const positionMatch = message.match(/position (\d+)/);
        if (positionMatch) {
          const pos = parseInt(positionMatch[1], 10);

          // Show a snippet around the error
          const contextLength = 50;
          const start = Math.max(0, pos - contextLength);
          const end = Math.min(value.length, pos + contextLength);
          const snippet = value.slice(start, end);

          // Build a pointer to the exact error character
          const pointer = " ".repeat(pos - start) + "^";

          console.error(`JSON parse error: ${message}`);
          console.error(snippet);
          console.error(pointer);
        }
      }
      throw error;
    }
  }
}
